import React from 'react';
import { Icon, Tag, Tooltip } from 'antd';

const statuses = {
  not_started: { label: 'Not Started', color: '#707070', icon: 'minus-circle' },
  pending: { label: 'Pending', color: '#a86200', icon: 'clock-circle' },
  cleared: { label: 'Cleared', color: '#237804', icon: 'check-circle' },
  expired: { label: 'Expired', color: '#ad4e00', icon: 'exclamation-circle' },
  action_required: { label: 'Action Required', color: '#a8071a', icon: 'warning' },
  unavailable: { label: 'Unavailable', color: '#595959', icon: 'question-circle' }
};

const DrugScreenStatus = ({ status, iconOnly = false }) => {
  const currentStatus = statuses[status] || statuses.unavailable;
  const accessibleLabel = `Drug screen: ${currentStatus.label}`;
  const iconOnlyStyle = iconOnly
    ? {
        alignItems: 'center',
        display: 'inline-flex',
        height: 25,
        justifyContent: 'center',
        marginBottom: -5,
        padding: 0,
        width: 25
      }
    : {};

  return (
    <Tooltip title={accessibleLabel}>
      <Tag
        color={currentStatus.color}
        aria-label={accessibleLabel}
        style={{ margin: 0, whiteSpace: 'nowrap', ...iconOnlyStyle }}
      >
        <Icon type={currentStatus.icon} aria-hidden="true" />
        {!iconOnly && ` ${currentStatus.label}`}
      </Tag>
    </Tooltip>
  );
};

export default DrugScreenStatus;
